import { render, staticRenderFns } from "./OrderLeft.vue?vue&type=template&id=1cd3440e&scoped=true"
import script from "./OrderLeft.vue?vue&type=script&lang=js"
export * from "./OrderLeft.vue?vue&type=script&lang=js"
import style0 from "./OrderLeft.vue?vue&type=style&index=0&id=1cd3440e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd3440e",
  null
  
)

export default component.exports